/* eslint
  prefer-const: 0,
  react/prop-types: 0,
  react/jsx-no-bind: 0
*/
import React from 'react';
import CargomaticCard from 'components/v2/card';
import ChevronUp from 'components/v2/icons/ChevronUpIcon';
import ChevronDown from 'components/v2/icons/ChevronDownIcon';
import { withTranslation } from 'react-i18next';
import DownloadPDFButton, { CarrierPayoutNumberCell, DateCell, PayoutStatusCell, MoneyCell, RawCell, } from '../renderer';
import { headersByFieldNames } from './mappings';
import DownloadIcon from 'components/v2/icons/DownloadIcon';
function renderRow(payout) {
    const { shipmentIds, items } = payout;
    return (React.createElement("tr", { "data-id": payout._id, key: payout._id },
        React.createElement(CarrierPayoutNumberCell, { data: payout }),
        React.createElement(RawCell, { className: "truncate", data: shipmentIds.map((id) => (React.createElement(React.Fragment, null,
                id,
                React.createElement("br", null)))) }),
        React.createElement(RawCell, { className: "truncate", data: items.length &&
                items.map((item) => (React.createElement(React.Fragment, null,
                    item,
                    React.createElement("br", null)))) }),
        React.createElement(DateCell, { data: payout.date_created }),
        React.createElement(DateCell, { data: payout.due_date }),
        React.createElement(MoneyCell, { data: payout.total, currency: payout === null || payout === void 0 ? void 0 : payout.currency }),
        React.createElement(PayoutStatusCell, { data: payout.status }),
        React.createElement("td", null,
            React.createElement(DownloadPDFButton, { payout: payout }))));
}
class PayoutList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sort: {
                key: props.sort.key,
                order: props.sort.order,
            },
        };
    }
    onHeaderClick(key) {
        const state = Object.assign({}, this.state);
        if (key === this.state.sort.key) {
            state.sort.order = state.sort.order === 'asc' ? 'desc' : 'asc';
        }
        else {
            state.sort = {
                key,
                order: 'asc',
            };
        }
        this.props.onSortChange(state.sort);
        this.setState(state);
    }
    renderHeaders() {
        const { t } = this.props;
        return (React.createElement("tr", { className: "" }, Object.keys(headersByFieldNames).map((key) => {
            const icon = this.state.sort.order === 'asc' ? React.createElement(ChevronDown, null) : React.createElement(ChevronUp, null);
            let thClassNames = [''];
            let sortArrow = '';
            if (key === this.state.sort.key) {
                thClassNames.push('current-sort');
                sortArrow = React.createElement("div", { className: "cursor-pointer" }, icon);
            }
            return (React.createElement("th", { "data-key": key, key: key, onClick: this.onHeaderClick.bind(this, key), className: thClassNames.join(' ') },
                React.createElement("div", { className: "flex items-center min-h-6 space-x-1" },
                    React.createElement("span", null, t(headersByFieldNames[key])),
                    sortArrow)));
        })));
    }
    renderInfo() {
        const { t } = this.props;
        return (React.createElement("div", { className: "flex justify-between items-center" },
            React.createElement("h3", { className: "" }, t('PAYOUT', { count: 1 })),
            React.createElement("button", { title: t('EXPORT_CSV'), className: "flex item-center button button-hollow-green", onClick: this.props.handleDownloadCSVReport },
                t('EXPORT_CSV'),
                React.createElement(DownloadIcon, null))));
    }
    render() {
        const { t } = this.props;
        const rows = this.props.payouts.map((payout) => renderRow(payout));
        return (React.createElement("div", { className: "mx-auto max-w-screen-2xl my-8 sm:my-32 xl:my-8" },
            React.createElement(CargomaticCard, { header: () => this.renderInfo() },
                React.createElement("div", { className: "card--no-x-padding card--no-top-padding -mb-4 sm:-mb-4" },
                    React.createElement("table", { className: "default-table" },
                        React.createElement("thead", null, this.renderHeaders()),
                        React.createElement("tbody", null, rows))))));
    }
}
export default withTranslation()(PayoutList);
